import React from 'react'
import './article.css'

export default ({ title, date, url, children }) => (
  <article className="article">
    <h1 className="article__title">
      {title}
    </h1>
    {date &&
      <div className="article__date">
        {date}
      </div>
    }
    <div className="article__excerpt">
      {children}
    </div>
    {url && <a className="button button--article" href={url} target="_BLANK" rel="noopener noreferrer">
      Leggi
      <i className="fas fa-external-link-alt"></i>
    </a>}
  </article>
)
